import { Loader, Modal } from 'shared/ui';
import { apiKeyStore } from '../../../entities/apiKey';

export const ConfirmationDeleteApiKeyModal = () => {
  const {
    confirmationDeleteModal,
    toggleConfirmationDeleteModal,
    isLoadingDelete,
    deleteApiKey
  } = apiKeyStore((state) => ({
    confirmationDeleteModal: state.confirmationDeleteModal,
    toggleConfirmationDeleteModal: state.toggleConfirmationDeleteModal,
    deleteApiKey: state.delete,
    isLoadingDelete: state.isLoadingDelete
  }));
  return (
    <Modal
      widthClasses="yep_ex-w-[24rem]"
      open={Boolean(confirmationDeleteModal)}
      onClose={() => toggleConfirmationDeleteModal(false)}
    >
      <div className="yep_ex-flex yep_ex-flex-col yep_ex-gap-4">
        <div className="yep_ex-text-neutral-900 yep_ex-text-md yep_ex-font-semibold yep_ex-pt-4">
          Are you sure you want to delete this API key?
        </div>
        <div className="yep_ex-text-sm">
          If this key is in use, it will stop working immediately.
        </div>
        <div className="yep_ex-flex yep_ex-gap-2">
          <button
            className="yep_ex-bg-red-600 yep_ex-text-white yep_ex-py-2 yep_ex-px-4 yep_ex-rounded disabled:yep_ex-opacity-50 yep_ex-flex yep_ex-gap-1"
            onClick={async () => {
              if (confirmationDeleteModal) {
                await deleteApiKey(confirmationDeleteModal);
                toggleConfirmationDeleteModal(false);
              }
            }}
            disabled={isLoadingDelete}
          >
            {isLoadingDelete && <Loader isButton size={20} />}
            Delete
          </button>
          <button
            className="yep_ex-bg-gray-200 yep_ex-text-gray-800 yep_ex-py-2 yep_ex-px-4 yep_ex-rounded"
            onClick={() => toggleConfirmationDeleteModal(false)}
          >
            Cancel
          </button>
        </div>
      </div>
    </Modal>
  );
};
